var map = {
	"./argentina.json": 4611,
	"./brazil.json": 6345,
	"./colombia.json": 6479,
	"./france.json": 3955,
	"./italy.json": 7525,
	"./master.json": 7382,
	"./mexico.json": 4015,
	"./peru.json": 8324,
	"./poland.json": 4696,
	"./portugal.json": 8346,
	"./testing.json": 3886,
	"./united-kingdom.json": 5299,
	"./usa.json": 736,
	"./venezuela.json": 4421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6118;